import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/omt-ams/")({
  beforeLoad: () => {
    throw redirect({
      to: "/omt-ams/dashboard",
    });
  },
  component: () => null,
});
